<template lang="html">
  <transition name="modal-fade" @after-leave="afterLeave">
    <div class="widget" @click="closeModal">
      <button v-if="modalType !== 'modal'" class="btn-ghost">退出预览</button>
      <div v-if="modalType === 'app'" class="modal">
        <img class="preview-img" src="/static/launchPreview/phone.png" @click="prevent" alt="img">
      </div>
      <div v-else-if="modalType === 'wap'" class="modal">
        <img class="preview-img" src="/static/launchPreview/phone.png" @click="prevent" alt="img">
        <iframe :src="preUrl" frameborder="0" width="240" height="440"></iframe>
      </div>
      <div v-else class="modal" @click="prevent">
        <div class="modal-head">{{ head }}</div>
        <div class="modal-body clearfix">
          <slot name="custom"></slot>
          <slot name="launchTemp"></slot>
        </div>
        <div class="modal-footer clearfix">
          <button v-if="modalType!=='alertTip'" class="modal-btn modal-btn-sub" @click="subEvent">{{ subText }}</button>
          <button class="modal-btn" @click="closeModal">{{ cancelText }}</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    modalType: {
      type: String,
      default: 'modal'
    },
    head: {
      type: String
    },
    subText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    preUrl: {
      type: String
    }
  },
  methods: {
    closeModal () {
      this.$emit('colse-modal')
    },
    subEvent () {
      this.$emit('sub-event')
    },
    prevent (e) {
      e.preventDefault()
      e.stopPropagation()
    },
    afterLeave () {
      this.$emit('init-props')
    }
  }
}
</script>

<style lang="less">
.modal-fade-enter-active, .modal-fade-leave-active {
  transition: all .4s;
}
.modal-fade-enter, .modal-fade-leave-active {
  opacity: 0;
  margin-top: -200px;
}
.widget{
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0,0,0,0.7);
  z-index: 999;
}
// .btn-ghost {
//   width: 88px;
//   height: 40px;
//   border-radius: 4px;
//   position: absolute;
//   top: 20px;
//   right: 30px;
//   background-color: rgba(0, 0, 0, 0);
//   color: #fff;
//   border: 1px solid #fff;
//   cursor: pointer;
//   outline: none;
// }
.modal {
  position: absolute;
  width: 450px;
  margin: auto;
  top: 38%;
  left: 50%;
  transition: translate(-50%, -50%);
  -webkit-transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  z-index: 1200;
  text-align: center;
  iframe {
    position: absolute;
    margin-top: 245px;
    left: 105px;
  }
  .preview-img {
    width: 280px;
    height: 575px;
    margin-top: 180px;
  }
  .modal-head {
    height: 40px;
    padding: 10px 5px;
    text-align: center;
    background-color: #4285f4;
    color: #fff;
    font-size: 16px;
    border-top-right-radius: 2px;
    border-top-left-radius: 2px;
  }
  .modal-body, .modal-footer {
    padding: 15px 30px;
    background-color: #fff;
    border-bottom-right-radius: 2px;
    border-bottom-left-radius: 2px;
  }
  .modal-footer {
    text-align: right;
  }
  .modal-btn {
    width: 60px;
    border-radius: 4px;
    padding: 6px 0;
    background-color: #f5f5f5;
    color: #333;
    outline: none;
    border: 1px solid #ccc;
    cursor: pointer;
    &+ button {
      margin-left: 20px;
    }
  }
  .modal-btn-sub {
    background-color: #4285f4;
    color: #fff;
  }
}

</style>



// WEBPACK FOOTER //
// modal.vue?af7f37da